import script from "./address-select.vue?vue&type=script&lang=ts&setup=true"
export * from "./address-select.vue?vue&type=script&lang=ts&setup=true"

import "./address-select.vue?vue&type=style&index=0&id=65fa0b66&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65fa0b66"]])

export default __exports__